import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { useManageInputFields } from "@/pages/quiz/hooks/useManageInputFields";
import { Button, ButtonType } from "@/components/common/button";
import { validateGallbladderDate } from "@/utils/validateField/gallbladder";
import { InputField } from "@/components/common/input";

type FormFieldName = "date";
type ContactFieldsValues = Record<FormFieldName, string>;

const validationFields = {
  date: {
    customValidator: validateGallbladderDate,
    required: true,
  },
};

const CustomGallbladderDate = ({
  question,
  questionValue,
  setQuestionValue,
  setQuestionAnswer,
}: QuizQuestionProps<ContactFieldsValues>) => {
  const { registerField, onValidateForm, error } = useManageInputFields(
    {
      setQuestionValue,
      questionValue,
    },
    validationFields
  );

  const isNoErrors = Object.values(error).every(
    (errorMessage) => !errorMessage
  );

  const isAllAnswered =
    Object.values(questionValue).filter(Boolean).length === 1;

  const isFormAnswered = isAllAnswered && isNoErrors;

  const onSubmit = async () => {
    if (isFormAnswered) {
      setQuestionAnswer(questionValue);
    }
  };

  return (
    <>
      <InputField
        {...registerField("date")}
        label="Date of surgery"
        type="date"
        placeholder="MM/DD/YYYY"
      />

      <Button
        type={ButtonType.CONTINUE}
        disabled={!isFormAnswered}
        onClick={onValidateForm(onSubmit)}
      />
    </>
  );
};

export { CustomGallbladderDate };
